<template>
  <v-card flat class="grey lighten-4" height="100%">
    <v-toolbar class="transparent elevation-0" flat>
      <v-toolbar-title>{{ $t('messenger.conversations.title') }}</v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <!-- TODO add progressbar for loading -->
    <v-list two-lines class="pb-0 list--full_height list--with_toolbar">
      <conversation-item
        v-for="conversation in conversations"
        :key="conversation._id"
        :conversation="conversation">
      </conversation-item>
    </v-list>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
  import ConversationItem from '@/components/messenger/ConversationItem.vue'
  import pagination from '@/mixins/pagination'
  export default {
    components: {
      ConversationItem
    },
    mixins: [
      pagination('skiliko/conversations')
    ],
    data () {
      const currentUser = this.$store.getters['skiliko/session/currentUser']
      return {
        filter: {
          userId: currentUser.chatable_id,
          page: 1
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../../variables"

  .list--full_height {
    height: 100%;
    overflow: scroll;

    &.list--with_toolbar {
      height: "calc(100% - %s)" % $toolbar-height;
    }
  }

  @media $display-breakpoints.sm-and-down {
    .card { background: white!important; }
  }
</style>



// WEBPACK FOOTER //
// src/components/messenger/Conversations.vue